"use client";

import { useState, useEffect, useCallback } from "react";
import { ChevronUp } from "lucide-react";

const SCROLL_THRESHOLD = 400;

export function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  const handleScroll = useCallback(() => {
    setVisible(typeof window !== "undefined" && window.scrollY > SCROLL_THRESHOLD);
  }, []);

  useEffect(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-full bg-[#FFB51D] text-[#131222] shadow-lg hover:bg-[#FFA500] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FFB51D]/25 transition-all duration-200 cursor-pointer animate-in fade-in"
    >
      <ChevronUp className="h-5 w-5 sm:h-6 sm:w-6" aria-hidden />
    </button>
  );
}
